// extracted by mini-css-extract-plugin
export var divider = "_4d-0";
export var dividerText = "_4d-1";